import { IState } from '../../../../../store';
import * as Formatters from '../../../../../utils/bargain_terms_formatter';
import { extractUndefinedValue } from '../../../../../utils/extractUndefinedValue';
import { FOfferType, getOfferType } from '../../../../../utils/offer_type';
import { getIsAgentAuthorised } from '../utils/getIsAgentAuthorised';
import { getIsAreaParts } from '../utils/getIsAreaParts';

type Term = [string, string | string[]];
type Terms = Array<Term>;

export function mapRentTerms(state: IState): Terms {
  const {
    offerData: { offer, user },
  } = state;
  const { bargainTerms, building, minVatPriceTotalPerMonthRur, pricesPerSquareMeterPerYear, vatPriceTotalPerMonthRur } =
    offer;

  const {
    agentBonus,
    agentFee,
    clientFee,
    hasGracePeriod,
    includedOptions,
    leaseTermType,
    minLeaseTerm,
    prepayMonths,
    securityDepositPrices,
    vatType,
  } = bargainTerms;

  const pricesPerSquareMeterPerYearRur = extractUndefinedValue(pricesPerSquareMeterPerYear?.rur);
  const isAreaParts = getIsAreaParts(offer);
  const isAgentAuthorised = getIsAgentAuthorised(user);

  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-143094, будет удалён в задаче CD-143198
   */
  const isCommercialNewVatTextEnabled = state.featureToggle.isCommercialNewVatTextEnabled;

  let terms: Terms = [
    ['Цена', Formatters.priceFormatter(offer)],
    ['Ставка', Formatters.AreaPerMetterFormatter(pricesPerSquareMeterPerYearRur, isAreaParts)],
    [
      'Налог',
      Formatters.vatTypeFormatter(
        vatType,
        vatPriceTotalPerMonthRur,
        minVatPriceTotalPerMonthRur,
        isCommercialNewVatTextEnabled,
      ),
    ],
    ['Обеспечительный платеж', Formatters.securityDeposites(securityDepositPrices)],
    ['Коммунальные платежи', Formatters.utilityCharges(includedOptions)],
    ['Эксплуатационные расходы', Formatters.operationalCosts(includedOptions)],
    ['Предоплата', Formatters.prepayMonths(prepayMonths)],
    ['Тип аренды', Formatters.leaseTypeFormatter(bargainTerms.leaseType)],
    ['Срок аренды', Formatters.leaseTermTypeFormatter(leaseTermType)],
    ['Минимальный срок аренды', minLeaseTerm ? `${minLeaseTerm} мес.` : '-'],
    ['Арендные каникулы', Formatters.hasGracePeriodFormatter(hasGracePeriod)],
    ['Стоимость парковки', Formatters.parkingFormatter(extractUndefinedValue(building?.parking))],
    ['Комиссия от клиента', Formatters.clientFee(clientFee)],
  ];

  if (getOfferType(offer) === FOfferType.Garage) {
    terms = terms.filter(([label]) => label !== 'Налог');
  }

  if (isAgentAuthorised) {
    terms.push(
      ['Комиссия от агента', Formatters.agentFee(agentFee)],
      ['Бонус агенту', Formatters.agentBonus(agentBonus)],
    );
  }

  if (agentBonus) {
    return terms.filter(([label]) => !['Комиссия от клиента', 'Комиссия от агента'].includes(label));
  }

  if (agentFee || clientFee) {
    return terms.filter(([label]) => label !== 'Бонус агенту');
  }

  return terms;
}
